import { render, staticRenderFns } from "./DetailMenus.vue?vue&type=template&id=4ee4f456"
import script from "./DetailMenus.vue?vue&type=script&lang=js"
export * from "./DetailMenus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports